import React from 'react';
import styled from 'styled-components';

import ChainExplorerLink from 'components/wallet/icons/explorer/ChainExplorerLink';
import { getWalletIcon } from 'components/wallet/icons/walletIcon';
import { walletsMap } from 'components/wallet/unlock/walletsListCore';
import { useDiscoverEip6961WalletByRdns } from 'lib/ethereum/walletDiscovery/walletDiscovery';
import { copyTextToClipboard, selectContents } from 'lib/string';
import { useSelector } from 'reduxState/store';

const Wrap = styled.div<{ $noPadding: boolean }>`
  display: inline-flex;
  align-items: center;
  padding: ${props => (props.$noPadding ? '0' : '0 20px')};
  overflow: hidden;
  max-width: 100%;
`;

const TitleBlock = styled.div`
  padding-right: 20px;
`;

const IconBlock = styled.div`
  padding-right: 10px;
  min-width: 30px;
  height: 20px;
  display: flex;
  align-items: center;
  > img {
    height: 20px;
  }
`;

const WalletAddress = styled.div`
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  padding-right: 10px;
  font-size: var(--small);
  cursor: copy;
`;

function CurrentWallet({
  hideTitle,
  noPadding,
  noBlockExplorer,
}: {
  hideTitle?: boolean;
  noPadding?: boolean;
  noBlockExplorer?: boolean;
}) {
  const wallet = useSelector(state => state.wallet);
  const discoveredWallet = useDiscoverEip6961WalletByRdns(
    wallet.walletDiscoveryRdns,
    true
  );

  const customIcon = discoveredWallet?.info.icon;
  const customTitle = discoveredWallet?.info.name;

  return (
    <Wrap
      $noPadding={noPadding === true}
      title={
        customTitle ||
        (wallet.walletType ? walletsMap[wallet.walletType]?.title : undefined)
      }
    >
      {!hideTitle && <TitleBlock>Active wallet:</TitleBlock>}
      {wallet.walletType && (
        <IconBlock title={walletsMap[wallet.walletType]?.title}>
          <img
            src={getWalletIcon(wallet.walletType, customIcon)}
            alt={wallet.walletType}
          />
        </IconBlock>
      )}
      {wallet.walletAddress ? (
        <>
          <WalletAddress
            title="Click to copy address to clipboard"
            onClick={e => {
              selectContents(e.target);
              copyTextToClipboard(wallet.walletAddress);
            }}
          >
            {wallet.walletAddress}
          </WalletAddress>
          {!noBlockExplorer && (
            <div>
              <ChainExplorerLink address={wallet.walletAddress} />
            </div>
          )}
        </>
      ) : (
        '-'
      )}
    </Wrap>
  );
}

export default CurrentWallet;
